import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @description Design: https://www.figma.com/design/WMwUaibi2LRURMHSKSxcj5/SSDK-Components?node-id=2214-5561&m=dev
 *
 * @param {Object} props - Component properties
 * @param {"dark" | "light"} [props.variant] - Badge Variant
 * @param {string} [props.className] - Additional class names to apply
 * @param {React.ReactNode} props.children - Content to display inside the badge
 */
export default function Badge({
  variant = 'light',
  className = '',
  children = null
}) {
  return (
    <div data-variant={variant} className={cn(styles.container, className)}>
      {children}
    </div>
  );
}
